import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorHandlingService } from '@app/core';

@Injectable()
export class MockDataService {
  constructor(private http: HttpClient, private toastr: ToastrService) {}

  /**
   * Recursos de los paises de la api restcountries: https://restcountries.eu
   *
   * @returns {Observable<any>}
   * @memberof MockDataService
   */
  getCountries(): Promise<string[]> {
    return new Promise((resolve, reject) => {
      this.http.get<any>('https://restcountries.eu/rest/v2/all').subscribe(
        data => {
          const formattedData: string[] = [];
          data.forEach((el: any) => {
            formattedData.push(el.name);
          });
          resolve(formattedData);
          this.toastr.success(`${data.length} países consultados.`, 'Operación exitosa');
        },
        err => {
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/forms/shared/mock-data.service.ts